import React from 'react';

/**
 * TabContent: Componente que renderiza el contenido de la pestaña activa.
 * 
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.activeTab - La pestaña activa actual.
 * @param {Array} props.contents - Lista de contenidos de pestañas con sus valores y componentes.
 * @returns {JSX.Element} El componente que renderiza el contenido de la pestaña activa.
 */
function TabContent({ activeTab, contents }) {
  return (
    <div className="tab-content mt-3">
      {contents.map((content) => (
        activeTab === content.value && (
          <div key={content.value}>
            {content.component}
          </div>
        )
      ))}
    </div>
  );
}

export default TabContent;